export default __webpack_public_path__ + "static/media/IconDesc_ModularFrameHeavy.256.2f1aa647.png";